import React from 'react';
import './PromotionMain.css';
import { Thumbnail } from '../PromotionThumbnail/Thumbnail';
import { PromotionNext } from '../PromotionNext';

export const PromotionMain = ({
    promotion,
}) => {
    return (
        <div className="asg-promotion-fold__main">
            <Thumbnail promotion={promotion} size="big" />
            <PromotionNext nextPromotion={promotion.nextPromotion} colors={promotion.colors} />
        </div>
    );
};
